import { Cartesian3, Cartographic, Math as CesiumMath } from "cesium";
import { SerializableCartographic } from "../models/serializable-cartographic";

export function convertCartesian3ToSerializableCartographic(cartesian: Cartesian3): SerializableCartographic {
    const cartographic = Cartographic.fromCartesian(cartesian);

    return {
        latitude: CesiumMath.toDegrees(cartographic.latitude),
        longitude: CesiumMath.toDegrees(cartographic.longitude),
        height: cartographic.height,
    };
}
